const TransPu = {
  navbar: {
    home: "Início",
    aboutus: "Sobre nós",
    product: "Produtos",
    productSub: {
      universalLifeInsurance: "Seguro de Vida Universal",
      indexedUniversal: (
        <>
          Seguro de Vida
          <br /> Universal Indexado
        </>
      ),
      termLifeInsurance: (
        <>
          Seguro de Vida
          <br />a Prazo
        </>
      ),
      criticalIllnessInsurance: (
        <>
          Seguro de
          <br /> Doenças Graves
        </>
      ),
      compareProduct: "Comparar produtos",
      compareDesc:
        "Descubra as principais diferenças do nosso portfólio de produtos de vida.",
    },
    agents: "Agentes",
    contactUs: "Contate-nos",
  },
  footer: {
    address: (
      <>
        American Fidelity International Ltd. (AFIL)
        <br /> The Grove, 21 Pine Rd, Belleville <br />
        Saint Michael, BB11113, Barbados
      </>
    ),
    number: "Telefone: 1 (246) 367-8874",
    email: "life-service@americanfidelity.com",
    fax: "Fax: (441) 292-0665",
    navLinks: {
      Home: "Início",
      About_Us: "Quem somos",
      Products: "Produtos",
      FAQs: "Perguntas Frequentes",
      American_Fidelity: "American Fidelity",
      Learn_More: "Saiba Mais",
      AFIBL: "AFIL",
      Superior_Plan: "Superior Plan",
      Universal_Life: "Vida Universal",
      Benefits: "Benefícios",
      How_It_Works: "Como funciona",
      Indexed_Universal_Life: "Vida Universal Indexada",
      Optima_Plan: "Optima Plan",
      Select_Term: "Select Term",
      Vital_Plan: "Vital Plan",
      Critical_Illness: "Doenças Críticas",
      ContactUs: "Entre em Contato",
      AdditionalBenefits: "Benefícios Adicionais",
      CoverageType: "Tipos de Cobertura",
    },
  },
  // WhyChoose HealthInsuranceHero.js
  provenExperience: "Experiência comprovada",
  provenExperienceDescription:
    "Segurando vidas no mercado há mais de 20 anos⁸.",
  flexibleProducts: "Produtos flexíveis",
  flexibleProductsDescription:
    "Seguro de vida adaptado à evolução das necessidades ao longo da vida.",
  lastingCommitment: "Compromisso duradouro",
  lastingCommitmentDescription:
    "Estamos comprometidos em acompanhá-lo ao longo do tempo, oferecendo revisões periódicas de sua apólice.",
  prestige: "Prestígio",
  PrestigeDescription:
    "Somos apoiados por uma reputação respeitada no mercado internacional. Nós nos esforçamos para manter os mais altos padrões e oferecer um serviço de primeira classe aos nossos clientes.",
  WhyChooseHeading: "Por que comprar um seguro de vida conosco?",
  WhyChooseDescription:
    "Ao escolher seu seguro de vida conosco, você pode esperar estabilidade, adaptabilidade e compromisso de longo prazo.",

  // Faqs left content
  faqsLefttitle: "Perguntas? Respostas",
  faqsLeftHeading: "Perguntas Frequentes",
  faqsLeftDescription:
    "Respondemos às principais dúvidas que possam surgir na hora de contratar um seguro de vida.",
  faqsLeftButton: "Entre em contato conosco!",

  // Our Credential content
  ourCredentialHeading: "Credenciais da American Fidelity Assurance Company",

  historyTab: "História",
  historyTitle: "Líder na indústria de seguros há mais de 62 anos.",
  historyDescription:
    "American Fidelity International Ltd. é membro da família de empresas American Fidelity®, juntamente com sua afiliada American Fidelity Assurance Company, uma organização líder no setor de seguros há mais de 62 anos.",
  historyLearnMore: "Saiba mais",

  cultureTab: "Cultura",
  cultureFeatureOne:
    "Certificado Melhores Lugares para Trabalhar<sup>3</sup> (2024-2025)",
  cultureFeatureTwo:
    "Melhores Lugares para Trabalhar para a Geração Millennials pela Revista Fortune <sup>(TM)</sup> 2024<sup>4</sup>",
  cultureFeatureThree:
    "Melhores Lugares para Trabalhar em Finanças e Seguros 2024<sup>5</sup> segundo a Fortune",
  cultureFeatureFour:
    "Melhores Lugares para Trabalhar em TI 2024<sup>6</sup> segundo a Computerworld",
  cultureFeatureFive:
    "Empresas que se Importam pela Revista PEOPLE 2021<sup>7</sup>",

  // Our Products Content
  ourProductHeading: "Nossos Produtos",

  universalLifeTab: "Vida Universal",
  universalLifeHeading: "Proteção financeira pela vida toda",
  universalLifeDescription:
    "O seguro de vida universal combina dois elementos importantes: proteção e poupança.",

  termLifeTab: "Vida a Termo",
  termLifeHeading:
    "Um produto competitivo que pode ajudar a garantir a proteção dos seus entes queridos.",
  termLifeDescription:
    "O seguro de vida pode ajudá-lo a proteger financeiramente seus entes queridos em caso de morte.",

  criticalIllnessTab: "Doença Crítica",
  criticalIllnessHeading: "Proteção em caso de Doenças Críticas",
  criticalIllnessDescription:
    "O benefício de doença crítica pode fornecer ao segurado proteção financeira no caso de sofrer de uma doença grave ou crítica coberta pela apólice.",

  productMoreButton: "Mais",
  productCompareButton: "Comparar planos",

  // About Us Banner
  aboutUsBannerTitle: "Compromisso com a Excelência e Liderança",
  aboutUsBannerDescription:
    "American Fidelity International Ltd. expande seus serviços de seguros de vida e saúde para clientes internacionais, reforçando sua visão de proteção para clientes latino-americanos.",
  aboutUsBannerButton: "Role para Saber Mais",

  americanfidelityTitle: "Família de Empresas American Fidelity",
  americanfidelityDescription:
    "Nossos pilares fundamentais de integridade, dedicação e excelência são a base de tudo o que fazemos.",
  americanfidelityDescription2:
    "A família de empresas American Fidelity é composta por várias companhias, incluindo a American Fidelity Corporation (AFC). A AFC, por meio de suas subsidiárias, oferece serviços financeiros, seguros e suporte em recursos humanos. A American Fidelity Assurance Company (AFA) e a American Fidelity International Ltd. são subsidiárias da AFC.",
  americanfidelityAmount: "*Valores em USD (Dólares americanos).",

  afaConsolidatedTextOne: "Liquidez Consolidada da AFA em 2023 <sup>8</sup>",
  afaConsolidatedTextTwo:
    "Benefícios acumulados consolidados da AFC pagos aos clientes em 2023 <sup>8</sup>",
  afaConsolidatedTextThree:
    "Renda líquida consolidada da AFC em 2023 <sup>8</sup>",

  //Values ​​that guide content
  valuesHeading: "Valores que nos guiam",
  valuesDescription:
    "As crenças fundamentais da American Fidelity para nossos clientes são sempre ser justos, financeiramente seguros, flexíveis, focados e orientados para o futuro.",
  valuesAMBestTab: "AM Best",
  AmBestTitle: "Classificação de Solidez Financeira: A+ (Superior)",
  AmBestDescription1: `Desde 1982, a American Fidelity Assurance Company tem recebido continuamente a classificação “A+” (Superior) da AM Best<sup>1</sup>.`,
  AmBestDescription2:
    "A AM Best, considerada uma das principais agências de classificação de seguros do país, baseia suas avaliações em uma análise da situação financeira e do desempenho operacional das seguradoras em áreas essenciais, como: solidez do balanço, desempenho operacional, perfil de negócios e gestão de riscos corporativos.",

  valuesWardsTab: "Ward's",
  valuesWardsTitle: "Prêmio Life Health Ward's 50® Companies 2024",
  valuesWardsDescription1:
    "A American Fidelity Assurance Company foi nomeada na lista de 2024 das 50© principais companhias de seguros de vida e saúde com melhor desempenho da Ward.",
  valuesWardsDescription2:
    "Esta honra reconhece o desempenho financeiro de 50 empresas. Cada empresa passou por todas as validações de segurança e consistência e alcançou desempenho superior ao longo dos cinco anos analisados<sup>2</sup>.",

  valuesOtherRewardsTab: "Outros Reconhecimentos",

  // Product Compare Content
  productCompareHeading: "Comparação de Produtos",
  productCompareDescription:
    "Conheça os principais diferenciais do nosso portfólio de produtos de vida.",

  termProductTitle: "Seguro a Termo",
  termProductDescription1:
    "Indivíduos e famílias que precisam de uma cobertura competitiva por um período limitado.",
  termProductDescription2:
    "Garante o pagamento de um benefício por falecimento previamente estabelecido aos beneficiários do segurado, caso o segurado venha a falecer durante o prazo especificado.",

  universalProductTitle: "Universal (Prime + Ultra III)",
  universalProductDescription1:
    "Pessoas que procuram flexibilidade em seu seguro.",
  universalProductDescription2:
    "Aqueles que desejam ajustar os prêmios e os benefícios por falecimento.",
  universalProductDescription3:
    "Indivíduos interessados em acumular valor em dinheiro.",

  indexaProProductTitle: "Indexa Pro IUL",
  indexaProProductDescription1:
    "Para aqueles que buscam potencial de crescimento do valor em dinheiro com base no S&P 500.",
  indexaProProductDescription2:
    "Aqueles que desejam uma combinação de desempenho a longo prazo e seguro de vida.",
  indexaProProductDescription3:
    "Aqueles que desejam uma combinação de desempenho de longo prazo e seguro de vida.",

  criticalProductTitle: "Doenças Críticas",
  criticalProductDescription1:
    "Um produto desenvolvido com um valor de benefício estipulado definido.",
  criticalProductDescription2:
    "É ativado no momento crítico do diagnóstico de uma doença grave (conforme descrito na apólice), proporcionando apoio financeiro.",

  guaranteedPremium: "Prêmio garantido",
  cashValue: "Valor em dinheiro utilizável",
  premiumFlexibility: "Flexibilidade em prêmios e frequência",
  deathBenefit: "Ajuste no valor do benefício por morte",
  loanDuration: "Duração de 10, 15, 20, 30, até 85 anos e até 100 anos",
  permanentPolicy: "Oportunidade de conversão para uma apólice permanente",
  interestCredit: "Crédito de rendimento com base no S&P 500®",
  interestCreditDesc:
    "(que pode aumentar ou diminuir devido às flutuações normais do mercado)",
  duringTerms: "(Durante o período)",

  // Critical Page content
  criticalIllnessHeading:
    "Proteção para ajudar com os custos de doenças graves",
  criticalIllnessDescription:
    "O seguro para doenças graves pode ajudar a oferecer proteção para cobrir os custos de uma doença crítica.",

  whyChooseIllness: {
    titleBold: "Por que você deve considerar a",
    titleRegular: "apólice de Doenças Críticas?",
    subtitle: "Doenças Críticas",
    description:
      "O benefício será pago diretamente a você para que possa usá-lo para ajudar a pagar despesas, tais como:",
    reasons: {
      medicalDebts:
        "Dívidas médicas não cobertas pelo seguro de saúde tradicional",
      lossOfIncome: "Perda de renda ou dívidas existentes",
      educationCosts:
        "Custos escolares ou universitários e custos com creche durante a recuperação",
      rehabilitation:
        "Reabilitação, cuidados pessoais na casa do segurado ou enfermeiro qualificado.",
    },
  },

  productOverview: {
    sectionTitle: "Doença Crítica",
    heading: "Visão geral do produto",
    whyConsiderHeadingBold: "Por que você deve considerar a",
    whyConsiderHeadingRegular: "apólice de Doenças Críticas?",

    features: {
      upto80: {
        title: "Até 80 anos",
        description: "Renovação garantida até os 80 anos de idade.",
      },
      activation90: {
        title: "Ativação em 90 dias",
        description: "Período de espera de 90 dias após a data de cobertura.",
      },
      flexibility: {
        title: "Flexibilidade de uso",
        description:
          "Pagamento único que pode ser usado para qualquer necessidade.",
      },
      extensiveCoverage: {
        title: "Cobertura ampla",
        description: "De $100,000 a $500,000.",
      },
    },
  },

  criticalIllnessTab1: {
    heading: "Doenças, Condições e Procedimentos Cirúrgicos cobertos",
    coveredFull: "100% Coberto",
    coveredHalf: "25% Coberto ou Apenas Uma Vez",
  },

  coveredFull: {
    description:
      "A Apólice de Doenças Críticas da American Fidelity International Ltd. paga 100% do valor máximo do benefício para as seguintes doenças, condições e cirurgias, conforme definido na apólice:",
    diseases: {
      alzheimers: "Doença de Alzheimer",
      aorticSurgery: "Cirurgia Aórtica",
      blindness: "Cegueira",
      cancer: "Câncer",
      heartAttack: "Ataque Cardíaco (Infarto do miocárdio)",
      multipleSclerosis: "Esclerose Múltipla",
      paralysis: "Paralisia",
      renalFailure: "Insuficiência Renal",
      severeBurns: "Queimaduras Graves",
      stroke: "Acidente Vascular Cerebral",
      deafness: "Surdez",
      organTransplant: "Transplante de Órgãos",
    },
  },

  coveredHalf: {
    description1:
      "A Apólice de Doenças Críticas da American Fidelity International Ltd. paga 25% do valor máximo de benefício apenas uma vez para os seguintes procedimentos, conforme definido na apólice:",
    procedures: {
      coronaryBypass: "Bypass da Artéria Coronária",
      heartValveSurgery: "Cirurgia da Válvula Cardíaca",
      coronaryAngioplasty: "Angioplastia Coronária",
    },
    description2:
      "A Apólice de Doenças Críticas da American Fidelity International Ltd. paga 25% do valor máximo de benefício até um valor máximo de $25,000 apenas uma vez para:",
  },

  // Terms Life Content
  termsBannerHeading:
    "Um produto competitivo que pode ajudar a garantir a proteção de seus entes queridos.",
  termsBannerDescription:
    "O seguro de vida temporário pode ajudar a oferecer proteção com o pagamento de um valor fixo ao seu beneficiário caso você faleça durante o período da apólice e enquanto ela estiver ativa.",

  select_term: "Selecionar Prazo",
  main_benefits: "Principais benefícios",
  of_the_policy: "da apólice",
  guaranteed_premiums_title: "Prêmios Garantidos",
  guaranteed_premiums_desc:
    "Garante que os prêmios da apólice não aumentarão durante o período do prazo.",
  conversion_option_title: "Opção de Conversão",
  conversion_option_desc:
    "Uma apólice de seguro de vida temporário pode ser convertida em uma apólice de seguro de vida permanente.",

  acceleratedDeathBenefitTitle: "Benefício por Morte Acelerada",
  acceleratedDeathBenefitDesc:
    "Oferece uma assistência financeira caso você sofra de uma doença terminal, conforme definido na apólice.",
  automaticBenefitRiderTitle:
    "Cláusula Adicional de Aumento Automático do Benefício (ABI)",
  automaticBenefitRiderDesc:
    "Esta cláusula aumenta automaticamente o benefício da apólice em 3% no final de cada ano durante os primeiros 5 anos da apólice. Uma vez atingido o aumento de 15% no benefício por morte original, o valor de benefício permanece nivelado enquanto a apólice permanecer ativa.",

  improve_protection: "Melhore sua proteção",
  with_additional_benefits: "com opções de benefícios adicionais",

  waiver_premium_title: "Isenção de Prêmio",
  waiver_premium_desc:
    "Esta cláusula adicional reembolsa o prêmio na íntegra se o segurado principal ficar totalmente incapacitado por pelo menos 180 dias, conforme definido na cláusula.",

  accidental_death_title: "Benefício por Morte Acidental e Desmembramento",
  accidental_death_desc:
    "Esta cláusula adicional oferece proteção extra se a morte resultar de um acidente ou proporciona benefícios adicionais em caso de perda de visão ou de um membro, conforme definido na cláusula.",

  return_premium_title: "Devolução do Prêmio",
  return_premium_desc:
    "Reembolsa todos os prêmios acumulados pagos menos quaisquer benefícios pagos no último dia do período do prazo, desde que a apólice ainda esteja ativa. Disponível para 30 anos e até 85 anos.",

  additional_insured_title: "Seguro para Segurado Adicional",
  additional_insured_desc:
    "Esta cláusula adicional oferece cobertura temporária para seu cônjuge, familiares e/ou parceiros de negócios.",

  variousTypesheading: "Vários tipos de cobertura disponíveis",
  termsTable: {
    termType: "Tipo de termo",
    issueAge: "Idade da emissão",
    minimumCovered: "Mínimo para cobrir todos os segurados",
    minimumAmount: "Valor Mínimo de Cobertura",
    term10: "Termo 10",
    term15: "Termo 15",
    term20: "Termo 20",
    term30: "Termo 30",
    term85: "Termo até os 85 anos ",
    term100: "Termo até os 100 anos ",
    years18_75: "18 a 75 anos",
    years18_70: "18 a 70 anos",
    years18_49: "18 a 49 anos",
    years50_65: "50 a 65 anos",
    years50_55: "50 a 55 anos",
    years50_80: "50 a 80 anos",
  },

  // Indexa universal content
  indexaBannerSubtitle: "Indexa Pro IUL",
  indexaBannerHeading:
    "Credita rendimentos com base no desempenho de um índice financeiro independente (S&P 500®)",
  indexaBannerDescription:
    "Seguro que, ao contrário das apólices de vida universal tradicionais, pode creditar rendimentos e tem o potencial de gerar valores de conta em sua apólice para necessidades futuras.",

  title_how_indexa_works: "Como funciona o Indexa Pro IUL?",
  how_indexa_worksDesc1:
    "Quando um pagamento de prêmio é feito, a cobrança de despesas de prêmio é deduzida e a parte restante é creditada no valor da sua conta.",
  how_indexa_worksDesc2: `<span class="md:font-semibold">
                      No início de cada mês,
                    </span>
                    o valor da conta é reduzido pelas deduções mensais.
                    <span class="md:font-semibold">
                      No final do mês,
                    </span>
                    o valor da conta na Conta Fixa é creditado com juros. A Conta Indexada é creditada com juros no Aniversário do Segmento.`,
  premiums_title: "Prêmios",
  premiums_info:
    "(Menos a taxa de despesas do prêmio, conforme mostrado na tabela da apólice.)",
  interest_title: "Rendimento",
  monthly_deductions_title: "Deduções mensais",
  monthly_deductions_info:
    "Pode incluir uma taxa administrativa, custo do seguro para a apólice, carga inicial, cobrança por US$ 1.000 do valor especificado e taxas do passageiro.",
  other_deductions_title: "Outras deduções",
  other_deductions_info:
    "(Incluindo quaisquer resgates parciais e custos por resgastes parciais.)",
  account_value: "Valor da Conta",

  fixed_and_indexed_accounts: "Conta fixa e conta indexada",
  fixed_account_title: "Conta Fixa",
  fixed_account_description:
    "A Conta Fixa oferece um crescimento positivo e constante graças à sua taxa de rendimento fixa.",
  fixed_account_benefits: "Pode ser adequado para você se você quiser:",
  fixed_account_stable_interest: "Taxas de rendimento mais estáveis",
  fixed_account_lower_risk: "Menor risco",

  indexed_account_title: "Conta Indexada",
  indexed_account_description:
    "A Conta Indexada oferece o potencial de maior crescimento no valor da conta porque está vinculada ao desempenho do índice S&P 500®.",
  indexed_account_benefits: "Pode ser adequado para você se:",
  indexed_account_higher_growth:
    "Você quer um maior potencial de crescimento do valor da conta.",
  indexed_account_higher_risk: "Você se sente confortável com um risco maior.",

  indexed_universal_product: "Produto Universal Indexado",
  indexed_account_title2: `A Conta Indexada <span class="font-semibold">tem um Teto, uma Taxa de Participação e um Piso.</span>`,

  indexed_account_description2: `<span class="font-bold">A Taxa Máxima</span> impõe um limite à taxa de juros que pode ser creditada.  
Portanto, <span class="font-bold">você ganhará juros quando o S&P 500® </span> tiver um desempenho positivo,  
mas nunca ganhará mais do que o limite imposto nas Contas Indexadas.`,

  participation_rate_description: `<span class="font-bold">A Taxa de Participação</span> 
                    determina o valor de aumento no índice usado para calcular a taxa de rendimento indexada.`,

  floor_description: `<span class="font-bold">O Piso</span> ajuda a proteger contra quedas do mercado. A taxa de rendimento creditada nunca será negativa, mesmo que o S&P 500® tenha um retorno negativo.`,

  indexaBenefits: {
    improve_protection: `<stong class="font-semibold">Melhore sua proteção </stong> com Opções de Benefícios Adicionais`,
    discover_more:
      "Descubra mais informações sobre o seguro de vida universal indexado.",
    watch_video: "Assista ao vídeo",
    benefitsOptions: {
      options1_title: "Clausula Adicional de Exoneração de Prêmio Especifico",
      options1_Desc: `Esta cláusula fornece um valor especificado a ser aplicado como prêmio ao valor da sua conta se você ficar totalmente inválido, conforme definido na cláusula. <br /> <span class="text-[#A8A9AC] ">(LR230B)</span>`,
      options2_title: "Cláusula Adicional de Morte Acidental e Desmembramento",
      options2_Desc: `Esta cláusula adicional oferece proteção extra se a morte resultar de um acidente ou proporciona benefícios adicionais em caso de perda de visão ou de um membro, conforme definido na cláusula. <br /> <span class="text-[#A8A9AC]">(LR234B)</span>`,
      options3_title:
        "Clausula Adicional de Seguro de Vida a Termo Nivelado para Filhos",
      options3_Desc: `Esta cláusula adicional oferece cobertura temporária para cada filho elegível, conforme definido na cláusula. <br />  <span class="text-[#A8A9AC] ">(LR231B)</span>`,
      options4_title:
        "Cláusula adicional de renda mensal por invalidez com benefício de cuidados de longo prazo",
      options4_Desc: `Esta cláusula fornece uma renda mensal se você ficar totalmente inválido, conforme definido na cláusula. Além disso, um benefício de cuidados de longo prazo será pago se você estiver cronicamente doente, conforme definido na cláusula.<br /> <span class="text-[#A8A9AC]">(LR233B)</span>`,
      options5_title: "Cláusula adicional de seguro temporário nivelado",
      options5_Desc: `Esta cláusula adicional oferece cobertura temporária para cônjuge, familiares e/ou parceiros de negócios. <br />  <span class="text-[#A8A9AC] ">(LR232B)</span>`,
    },
  },

  // Universal Page content
  universalBannerHeading:
    "Seguro de vida permanente que combina dois elementos:",
  universalBannerDesc: "Valor em dinheiro e proteção",

  universalBenefits: {
    improve_protection: `<stong class="font-semibold">Melhore sua proteção </stong> com Opções de Benefícios Adicionais`,
    benefitsOptions: {
      options1_title: "Clausula Adicional de Exoneração de Prêmio Especifico",
      options1_Desc: `Esta cláusula fornece um valor especificado a ser aplicado como prêmio ao valor da sua conta se você ficar totalmente inválido, conforme definido na cláusula. <br /> <span class="text-[#A8A9AC] ">(LR154B)</span>`,
      options2_title: "Cláusula Adicional de Morte Acidental e Desmembramento",
      options2_Desc: `Esta cláusula adicional oferece proteção extra se a morte resultar de um acidente ou proporciona benefícios adicionais em caso de perda de visão ou de um membro, conforme definido na cláusula. <br /> <span class="text-[#A8A9AC]">(LR195B)</span>`,
      options3_title: "Cláusula adicional de seguro temporário nivelado",
      options3_Desc: `Esta cláusula adicional oferece cobertura temporária para cônjuge, familiares e/ou parceiros de negócios. <br />  <span class="text-[#A8A9AC] ">(LR232B)</span>`,
      options4_title:
        "Clausula Adicional de Seguro de Vida a Termo Nivelado para Filhos",
      options4_Desc: `Este adicional oferece cobertura temporária para cada filho elegível, conforme definido no adicional. <br /> <span class="text-[#A8A9AC]">(LR121B)</span>`,
      options5_title:
        "Cláusula Adicional de Renda Mensal por Invalidez com Cuidados Prolongados",
      options5_Desc: `Esta cláusula fornece uma renda mensal se você ficar totalmente inválido, conforme definido na cláusula. Além disso, um benefício de cuidados de longo prazo será pago se você estiver cronicamente doente, conforme definido na cláusula.<br /> <span class="text-[#A8A9AC]">(LR162B)</span>`,
    },
  },

  main_benefits_title: "Principais benefícios da nossa apólice",
  adjustable_premiums: "Prêmios Ajustáveis",
  build_cash_value: "Acumulação de Valores em Dinheiro",
  adjustable_death_benefit: "Benefício de Morte Ajustável",

  universeProduct_subtitle: "Produtos Universais",
  universeProduct_heading: `<span class="font-semibold">Proteção</span> mais valores em dinheiro dentro da mesma apólice`,
  universeProtection_tab: "Proteção",
  universeProtection_title: "O seguro de vida pode ajudar com:",
  universeProtection_desc: `Substituição de renda <br />
             Pagamento financiamento imobiliário e outras dívidas
              <br />
              Pagar as despesas funerárias
              <br />
              Financiamento da educação universitária para crianças
              <br />
              Pagamento de impostos de transferência de herança`,

  universeCashValue_tab: "Valor em Dinheiro",
  universeCash_title: "A acumulação de valor em dinheiro pode ser usada para:",
  universeCash_desc: `Complemento de aposentadoria <br />
             Compras importantes (casa, empresa) <br />
              Necessidades emergenciais de caixa`,

  universal_types_title: "Dois tipos de produtos de Seguro de Vida Universal",
  indexed_universal_life: "Seguro de Vida Universal Indexado",
  indexed_universal_life_desc: `O seguro de vida universal indexado (IUL) é uma apólice de seguro de vida permanente que oferece um benefício por falecimento e um componente de valor em dinheiro. A conta de valor em dinheiro pode render juros acompanhando um índice do mercado de ações, como o
                                  <span class="font-bold">
                                    Standard & Poor’s® S&P 500® INDEX
                                  </span> que pode subir ou descer devido às flutuações normais do mercado.`,
  indexed_min_death_benefit:
    "Valor mínimo do benefício por morte requerido $ 250.000",
  indexed_issue_ages: "Idades da edição: 18-80 anos de idade",
  indexed_learn_more: "Saiba mais sobre o Indexa Pro",
  universal_life: "Seguro de Vida Universal",
  universal_life_desc:
    "Uma apólice de seguro de vida permanente que oferece o benefício de acumulação de valores em dinheiro a taxas competitivas.",
  universal_min_death_benefit:
    "Valor mínimo do benefício por morte requerido $ 100.000",
  universal_issue_ages: "Idades da edição: 18-80 anos de idade",
  universal_available_products: "Dois produtos disponíveis:",
  universal_product_1: "Platina Ultra III",
  universal_product_2: "Prime",

  // other pages title
  securePageTitle: "Práticas de Navegação Segura",
  termsPageTitle: "Termos de Uso",
  footnotesPageTitle: "Rodapé",
  privacyPageTitle: "Aviso de Privacidade em vigor desde Janeiro de 2025",
};

export default TransPu;
